import React, { useContext } from 'react';
import '../styles/global.css';
import { SearchContext } from '../context/SearchContext';

const menuData = {
  Starters: [
    
      {
        name: "Paneer Tikka",
        price: "₹180",
        image: "https://images.unsplash.com/photo-1666001120694-3ebe8fd207be?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8cGFuZWVyJTIwdGlra2F8ZW58MHx8MHx8fDA%3D"
      },
      {
        name: "Veg Manchurian",
        price: "₹100",
        image: "https://i.ytimg.com/vi/xkMbJCtaaqA/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLDrMLgdijp9TJ92IUYugdtisp2tIw"
      },
      {
        name: "Chicken 65",
        price: "₹220",
        image: "https://www.shutterstock.com/image-photo/chicken-65-dish-garnished-lemon-600nw-2452136955.jpg"
      },
      {
        name: "Veg Spring Rolls",
        price: "₹150",
        image: "https://t3.ftcdn.net/jpg/00/89/95/08/360_F_89950874_LVsh6xkVvHEPZUqH60qZRkUq5VNfsba3.jpg"
      },
      {
        name: "Gobi Manchurian",
        price: "₹160",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT4LUNqARqwrtTGGUZcySGiuTBYENjBhQC_ugto5WxWAGUAwzB_66-uRNll-XOgxde6TAzOkiPLCEwf1jrXIx98NnpUc8Ffdz1IJT658A"
      },
      {
        name: "Chicken Lollipop",
        price: "₹240",
        image: "https://www.cafegoldenfeast.com/wp-content/uploads/2025/01/Chicken-Lollipop.jpg"
      },
      {
        name: "Hara Bhara Kabab",
        price: "₹170",
        image: "https://cdn.zeptonow.com/production///tr:w-600,ar-100-100,pr-true,f-auto,q-80/web/recipes/hara-bhara-kebab.png"
      },
      {
        name: "Tandoori Chicken",
        price: "₹280",
        image: "https://www.easycookingwithmolly.com/wp-content/uploads/2023/11/air-fryer-whole-tandoori-chicken-3.jpg"
      },
      {
        name: "Crispy Corn",
        price: "₹130",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSX39T_HJRerlrIvi7i7xEM5c-UwrMTy2kwkA&s"
      },
      {
        name: "Fish Fingers",
        price: "₹260",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTh2JszlxQ7XuaucmgcgVJ4MnUVs_PGItK5-A&s"
      },
      {
        name: "Cheese Balls",
        price: "₹140",
        image: "https://www.funfoodfrolic.com/wp-content/uploads/2018/05/Chicken-Cheese-Balls.jpg"
      },
      {
        name: "Tandoori Mushrooms",
        price: "₹190",
        image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQymdlUqzBKc8Q61oK05ekDWFyt1WohFQ0U6w&s"
      }
    ],
  
  
  "Main Course": [
    {
      name: "Butter Chicken",
      price: "₹320",
      image: "https://thekitchenpaper.com/wp-content/uploads/2018/01/indian-butter-chicken-recipe-1.jpg"
    },
    {
      name: "Paneer Butter Masala",
      price: "₹280",
      image: "https://cdn.zeptonow.com/production///tr:w-600,ar-100-100,pr-true,f-auto,q-80/web/recipes/paneer-butter-masala.png"
    },
    {
      name: "Chicken Biryani",
      price: "₹250",
      image: "https://www.indianhealthyrecipes.com/wp-content/uploads/2021/12/chicken-biryani-recipe.jpg"
    },
    {
      name: "Veg Pulao",
      price: "₹180",
      image: "https://www.indianhealthyrecipes.com/wp-content/uploads/2018/07/pulao-recipe.jpg"
    },
    {
      name: "Dal Makhani",
      price: "₹160",
      image: "https://sinfullyspicy.com/wp-content/uploads/2015/03/1200-by-1200-images-1.jpg"
    },
    {
      name: "Rogan Josh",
      price: "₹350",
      image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQgZRD0QKjIQ3bSuy0HLwuUdkb4qMQnJ4DV8g&s"
    },
    {
      name: "Chole Bhature",
      price: "₹160",
      image: "https://cdn.zeptonow.com/production///tr:w-600,ar-100-100,pr-true,f-auto,q-80/web/recipes/chola-bhatura.png"
    },
    {
      name: "Fish Curry",
      price: "₹300",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqVPc49Ep0ehv9ZskczFpcOsCZKy56lji7Zw&s"
    },
    {
      name: "Mushroom Masala",
      price: "₹220",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBIsz1OCmAKwBXhimJqNDNcJtDsbyPyFm5gg&s"
    },
    {
      name: "Palak Paneer",
      price: "₹200",
      image: "https://static.toiimg.com/thumb/53093667.cms?imgsize=325892&width=800&height=800"
    },
    {
      name: "Mutton Curry",
      price: "₹370",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTOp3hGBUF_gEjjloh0kE-419OcmCToeNN0rw&s"
    },
    {
      name: "Jeera Rice",
      price: "₹120",
      image: "https://www.indianhealthyrecipes.com/wp-content/uploads/2015/12/jeera-rice-recipe-500x500.jpg"
    }
  ],
  "Soft Drinks": [
    {
      name: "Coca Cola",
      price: "₹40",
      image: "https://jagsfresh-bucket.s3.amazonaws.com/media/package/img_one/2020-10-17/Coca_Cola_Soft_Drink_bottle_2l.jpg"
    },
    {
      name: "Pepsi",
      price: "₹40",
      image: "https://m.media-amazon.com/images/I/61rmYnJvWzL.jpg"
    },
    {
      name: "Sprite",
      price: "₹40",
      image: "https://storage.googleapis.com/shy-pub/22159/1692791801108_SKU-1013_0.jpg"
    },
    {
      name: "Fanta",
      price: "₹40",
      image: "https://cdn.uengage.io/uploads/18085/image-546261-1694859044.jpeg"
    },
    {
      name: "Thums Up",
      price: "₹45",
          image: "https://5.imimg.com/data5/SELLER/Default/2023/7/327562371/DS/IW/PV/189968624/thums-up-png-500x500.png"
    },
    {
      name: "Mountain Dew",
      price: "₹40",
      image: "https://images.albertsons-media.com/is/image/ABS/108050480?$grid-product-card-desktop$&defaultImage=Not_Available"
    },
    {
      name: "Limca",
      price: "₹40",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTMOncbNCeZfRbBwbX63MorD_VXXI53NFb7xw&s"
    },
    {
      name: "Appy Fizz",
      price: "₹45",
      image: "https://5.imimg.com/data5/SELLER/Default/2022/10/LT/VO/HJ/122397313/600ml-appy-fizz.jpg"
    },
    {
      name: "Red Bull",
      price: "₹120",
      image: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/8.4_floz_can_of_Red_Bull_Energy_Drink.jpg/1200px-8.4_floz_can_of_Red_Bull_Energy_Drink.jpg"
    },
    {
      name: "Maaza",
      price: "₹35",
      image: "https://taqumart.in/wp-content/uploads/2025/03/Maaza.jpg"
    },
    {
      name: "Slice",
      price: "₹35",
      image: "https://www.bbassets.com/media/uploads/p/l/265884_12-slice-thickest-mango-drink.jpg"
    },
    {
      name: "Cold Coffee",
      price: "₹90",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSPg5JowFsGBE7iiMri8Zwx0RhwQUto8ceYXg&s"
    }
  ],
  "Desserts": [
    {
      name: "Gulab Jamun",
      price: "₹80",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3aJrkMZfZWaRkqQu36Y9TBzYlCrkKHvy7mw&s"
    },
    {
      name: "Rasgulla",
      price: "₹70",
      image: "https://prashantcorner.com/cdn/shop/products/RASGULLA_2457ea2c-400a-4130-b540-b77966e63d07.jpg?v=1673073151&width=1946"
    },
    {
      name: "Chocolate Brownie",
      price: "₹120",
      image: "https://recipesblob.oetker.in/assets/9a89b75f976642dcab8ae407e2f4344e/750x910/chocolate-brownie.webp"
    },
    {
      name: "Ice Cream Sundae",
      price: "₹150",
            image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRt8D1gFfWCmaxeGcRddNEgzXRmVLkH4sibxQ&s"
    },
    {
      name: "Kaju Katli",
      price: "₹110",
      image: "https://anandhaassweets.com/cdn/shop/files/PremiumKajuKatli.png?v=1715680562"
    },
    {
      name: "Mango Mousse",
      price: "₹130",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQPu5jLmE9osbtk7vfsGyku5cNaQBeS30y6CQ&s"
    },
    {
      name: "Strawberry Cheesecake",
      price: "₹160",
      image: "https://drivemehungry.com/wp-content/uploads/2022/07/strawberry-cheesecake-11.jpg"
    },
    {
      name: "Carrot Halwa (Gajar Ka Halwa)",
      price: "₹100",
      image: "https://drivemehungry.com/wp-content/uploads/2022/07/strawberry-cheesecake-11.jpg"
    },
    {
      name: "Chocolate Lava Cake",
      price: "₹140",
      image: "https://www.melskitchencafe.com/wp-content/uploads/2023/01/updated-lava-cakes7.jpg"
    },
    {
      name: "Kulfi",
      price: "₹90",
      image: "https://recipes.timesofindia.com/thumb/84786580.cms?width=1200&height=900"
    },
    {
      name: "Fruit Custard",
      price: "₹80",
      image: "https://www.indianhealthyrecipes.com/wp-content/uploads/2021/05/fruit-custard.jpg"
    },
    {
      name: "Tiramisu",
      price: "₹180",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRdi-Md2rked5AZ1JgeUpNy1fZwYD6A7jHyL0RDGk1PNW9CjQFGQSY1RL_sb3XxFvtoCJk&usqp=CAU"
    }
  
  ]
};



// (keep your menuData here)

function Menu() {
  const { query } = useContext(SearchContext);

  return (
    <div className="menu-container">
      <h2 className="menu-title">Our Menu</h2>

      {Object.keys(menuData).map((section) => {
        const filteredItems = menuData[section].filter((item) =>
          item.name.toLowerCase().includes(query)
        );

        // Skip rendering the section if no items match
        if (filteredItems.length === 0) return null;

        return (
          <div key={section} className="menu-section">
            <h3 className="menu-section-title">{section}</h3>
            <div className="menu-items">
              {filteredItems.map((item, index) => (
                <div key={index} className="menu-card">
                  <img src={item.image} alt={item.name} className="menu-image" />
                  <div className="menu-details">
                    <h4 className="dish-name">{item.name}</h4>
                    <p className="dish-price">{item.price}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Menu;
